import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  formSection: {
    paddingTop: 10,
    marginBottom: 10,
    borderWidth: 2,
    borderStyle: 'solid',
    borderImage: `linear-gradient(
        to right, 
        rgba(0, 0, 0, 0),
        lightgray, 
        rgba(0, 0, 0, 0)
      ) 1 1 100%;`,
  },
});

const FormSection = ({ children }) => {
  const classes = useStyles();
  return <fieldset className={classes.formSection}>{children}</fieldset>;
};

export default FormSection;
